import API from "../services/apiservices";

async function getid() {
  await API.getLocalDBDocument("ambientesStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].id;
    } else {
      return 0;
     }
  });
}

export default {
  namespaced: true,
  namespace: "ambientesStore",

  state: {
    storename: "ambientesStore",
    ambientes: {
      id: 0,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "ambientesStore", route: "Servicos/Ambientes/Get", setter: "setAmbientes"}),
    gtxAmbientes: (state) => state.ambientes,
    gtxAmbientes_data: (state) => state.ambientes.data || [],
    gtxAmbientes_GetById: (state) => (id) => state.ambientes.data.find(f => f.id == id) || {value: 0, text: ""},
    gtxAmbientes_selected: (state, getters) => state.ambientes.data.find(f => f.id == getters.gtxAmbientes_id),
    gtxAmbientes_select: (state) => (id) => state.ambientes.data.find(f => f.id == id),
    gtxAmbientes_dataoptions: (state) => (marca) => state.ambientes.data ? state.ambientes.data.filter(f=>f.Marca === marca).map(o=>({value: o.id, text: o.Nome})).sort((a, b) => a.text.localeCompare(b.text)) : [],
    gtxAmbientes_id: (state) => state.ambientes.id,
    gtxAmbientes_nome: (state, getters) => {
      const data = state.ambientes.data.find(f => f.id == getters.gtxAmbientes_id);
      return data ? data.Nome : "";
    },
    gtxAmbientes_error: (state) => state.ambientes.error,
  },

  mutations: {
    setAmbientes: (state, ambientes) => (state.ambientes = {api: ambientes.apiresponse, data: ambientes.data, id: ambientes.data[0].id, error: null}),
    setAmbientesid: (state, id) => (state.ambientes.id = id),
    setAmbientesdata: (state, data) => (state.ambientes.data = data),
  },

  actions: {
    actAmbientesGet({ commit, getters }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "ambientesStore", route: "Servicos/Ambientes/Get", setter: "setAmbientes"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], id: 0, error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
          });
        }).catch((error) => {
          API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
            if (doc && doc.data) {
              commit(getters.gtxStore.setter, doc.data);
              res(doc.data);
            } else {
              const emptyData = { data: [], id: 0, error: error.message };
              res(emptyData);
            }
          });
        });
        } catch (err) {
          rej(err);
        }
      });
    },
    actAmbientesMudaCodigo({ commit, getters }, id) {
      const data = getters.gtxAmbientes_data.find(f => f.id == id);
      if (data) {
        commit("setAmbientesid", data.id);
      }
    }
  },
};
